import { DatePrecision } from '../DatePrecision';
import type { DateRepresentation } from '../DateRepresentation';
import { safeParseDate } from '../parse/date';
import { formatEST } from './formatEST';

function padNumber(value: number, digits: number): string {
	return value.toString().padStart(digits, '0');
}

/**
 * Direct function for getting a normalized ISO date string from a Date object
 *
 * @param dateValue
 * @returns
 */
export function normalizeISODate(dateValue: Date): string {
	const year = padNumber(dateValue.getUTCFullYear(), 4);
	const month = padNumber(dateValue.getUTCMonth() + 1, 2);
	const day = padNumber(dateValue.getUTCDate(), 2);
	const hours = padNumber(dateValue.getUTCHours(), 2);
	const minutes = padNumber(dateValue.getUTCMinutes(), 2);
	const seconds = padNumber(dateValue.getUTCSeconds(), 2);
	const milliseconds = padNumber(dateValue.getUTCMilliseconds(), 3);
	const prefix = `${year}-${month}-${day}T${hours}:${minutes}`;

	if (milliseconds !== '000') {
		return `${prefix}:${seconds}.${milliseconds}Z`;
	}

	if (seconds !== '00') {
		return `${prefix}:${seconds}Z`;
	}

	return `${prefix}Z`;
}

export function formatISO(date: DateRepresentation, formatType?: DatePrecision): string | undefined {
	const dateValue = safeParseDate(date);
	if (!dateValue) {
		return undefined;
	}

	if (formatType === DatePrecision.Day) {
		return formatEST(dateValue, 'yyyy-MM-dd');
	}

	// Return the normalized ISO string without redundant precision.
	return normalizeISODate(dateValue);
}
